import * as React from 'react';
import { Broadcast } from 'react-broadcast';

import { Renderer } from './components/Renderer';
import * as actions from './actions';

export default class App extends React.Component {
  render() {
    const context = { ...actions, globals: {} };
    return (
      <Broadcast channel="context" value={context}>
        <div className="App full-height">
          <Renderer content="root" />;
        </div>
      </Broadcast>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.tsx